// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"85968d9d","889":"f827fb28"}[chunkId] + ".chunk.js";
};